var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m181.536 127.821-91.536 26.749-20.423 81.012c3.533 29.756 9.111 57.611 27.508 73.206l151.819 123.386 18.368 14.132c27.654 21.271 53.848-8.456 32.823-30.429-.292-.322-.613-.644-.934-.966 7.096 5.969 15.068 7.666 22.047 6.525 15.36-2.487 25.873-18.755 11.739-33.941 27.625 22.061 51.22-13.079 29.581-32.361 24.121 7.607 50.402-23.671 25.347-50.238-.175-.205-.38-.439-.584-.644l-62.813-93.512-84.247-53.983z",
    fill: "#ffbc85",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m246.626 434.807c23.361-24.9-10.717-53.544-29.552-36.662l-20.178 19.194c-.234.234-.438.439-.672.614-16.937 17.029 13.842 55.826 39.305 28.674z",
    fill: "#ffe5c1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m181.886 363.415-21.317 22.354-.088.117c-10.688 11.353-3.271 28.762 9.374 35.55 7.826 4.213 17.638 4.389 26.369-3.482l22.836-.351-1.986-19.457 2.92-2.75c22.836-21.71-10.133-59.22-35.86-34.35z",
    fill: "#ffe5c1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m143.807 332.781-19.974 21.213-2.803 3.014c-19.711 20.92 15.594 53.866 35.947 32.507l3.504-3.628c.292-.322 21.697-2.546 24.033-2.809l-.38-22.032 6.833-7.168c23.507-24.665-13.228-57.143-35.597-33.355z",
    fill: "#ffe5c1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m97.085 308.788-6.775 7.344c-20.85 22.647 10.221 58.752 33.523 37.861l19.127-2.955.847-18.258c18.893-21.388-14.046-59.454-39.977-31.307z",
    fill: "#ffe5c1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m125.703 64.27-92.715 89.27-26.37 25.367c-8.585 8.251-8.848 22.032-.613 30.634l39.335 41.021c2.278 2.37 6.103 2.458 8.498.176l15.74-15.156 111.959-107.761 13.9-13.401c2.395-2.282 2.482-6.115.175-8.514l-39.335-41.021c-8.235-8.603-21.989-8.866-30.574-.615z",
    fill: "#7bacdf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m302.022 219.46-28.15 6.437 11.038 11.206 85.269 84.793.584.644c10.279 10.884 11.914 22.53 8.644 32.009 16.849-6.437 27.566-29.405 8.468-49.653l-.584-.644-25.581-25.426z",
    fill: "#f5a96c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m181.536 127.821-17.93 17.233 56.038 27.65 20.587-15.946z",
    fill: "#f5a96c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m240.231 156.758-20.587 15.946-19.39 14.981c-48.971 37.92-8.352 75.371 20.704 62.527l32.677-19.691 20.237-4.623 28.15-6.437 59.688 59.367 25.581 25.426c16.09-6.027 38.838-23.407 63.397-62.966l-37.331-78.105-87.185-41.769-22.368 17.877c-3.679 2.926-2.57 2.37-7.213 2.224-16.791-.527-38.137 1.141-50.665 10.826z",
    fill: "#ffe5c1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m240.144 217.5-32.677 19.691c-8.906 3.95-18.923 3.16-27.099-.936 7.096 13.635 25.435 20.657 40.59 13.957l32.677-19.691 20.237-4.623 27.8-6.349c-12.878-11.031-15.185-12.64-41.32-6.642z",
    fill: "#fed1a3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m430.363 221.713c-21.872 35.199-42.284 52.842-57.848 60.566-1.752.878-3.446 1.609-5.081 2.224l19.857 19.75c16.09-6.027 38.838-23.407 63.397-62.966z",
    fill: "#fed1a3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m93.99 94.816c8.585-8.163 22.252-7.841 30.457.702l39.335 41.021c2.278 2.399 2.219 6.232-.175 8.514l17.93-17.234 13.9-13.401c2.395-2.282 2.482-6.115.175-8.514l-39.335-41.021c-8.235-8.602-21.989-8.866-30.574-.614z",
    fill: "#3987d0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m83.448 333.454c.204 19.165 22.573 36.515 40.386 20.54l12.527-13.284 7.446-7.929c7.797-8.836 6.746-20.481 1.051-29.171-.029 5.091-1.723 10.182-5.607 14.6l-13.258 14.074-6.687 7.139c-12.993 11.615-28.383 5.559-35.858-5.969z",
    fill: "#fed1a3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m116.154 376.933c4.672 15.683 26.486 27.65 40.824 12.581l3.504-3.628c.029-.059.058-.088.088-.117l21.317-22.354c.759-.849 1.489-1.639 2.249-2.37l6.833-7.168c12.673-13.284 7.855-28.849-2.803-36.662 1.927 7.168.38 15.449-6.804 22.968l-6.833 7.168c-.759.731-1.489 1.521-2.249 2.341v.029l-21.317 22.354c-.029.029-.058.059-.117.088l-3.475 3.657c-9.521 10.008-22.311 8.106-31.217 1.113z",
    fill: "#fed1a3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m196.896 417.34 15.564-14.776 4.614-4.418 2.92-2.75c12.148-11.557 8.498-27.591-1.489-36.311 2.132 7.637.555 16.268-6.804 23.261l-2.891 2.75-8.235 7.812-11.973 11.411-.672.585c-8.731 7.871-18.543 7.695-26.369 3.511-1.927-1.053-3.738-2.341-5.373-3.833 1.927 6.934 7.096 13.342 13.666 16.853 7.826 4.213 17.638 4.389 26.369-3.482z",
    fill: "#fed1a3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m246.626 434.807c11.681-12.464 8.994-25.836 1.051-33.999-.175 5.53-2.511 11.47-7.884 17.175l-11.097 11.85c-13.637 14.513-28.793 10.153-37.32.351.117 17.76 23.829 38.125 44.153 16.444z",
    fill: "#fed1a3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362.525 362.867c-1.884 0-3.774-.686-5.263-2.072l-31.129-28.996c-3.123-2.91-3.298-7.802-.391-10.928 2.907-3.125 7.796-3.301 10.921-.392l31.129 28.996c3.123 2.91 3.298 7.802.391 10.928-1.522 1.637-3.587 2.464-5.658 2.464z",
    fill: "#f5a96c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m332.944 395.228c-1.884 0-3.774-.686-5.263-2.073l-31.158-29.025c-3.123-2.91-3.298-7.801-.39-10.927 2.905-3.125 7.795-3.302 10.92-.391l31.158 29.025c3.123 2.91 3.298 7.801.39 10.927-1.522 1.636-3.587 2.464-5.657 2.464z",
    fill: "#f5a96c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m300.18 423.667c-1.882 0-3.77-.685-5.258-2.068l-15.856-14.746c-3.126-2.908-3.305-7.799-.4-10.927 2.904-3.128 7.794-3.307 10.92-.401l15.856 14.746c3.126 2.908 3.305 7.799.4 10.927-1.522 1.639-3.589 2.469-5.662 2.469z",
    fill: "#f5a96c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m326.171 121.413 104.191 100.3 20.324 19.574 7.476 7.198c2.395 2.282 6.22 2.194 8.498-.176l20.529-21.418 18.806-19.604c8.235-8.602 7.972-22.383-.613-30.634l-18.193-17.497-100.891-97.14c-8.585-8.251-22.339-7.988-30.574.614l-39.335 41.021c-2.307 2.399-2.219 6.232.175 8.514z",
    fill: "#fe636e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m479.509 151.725v.029zm-18.28 50.151-20.529 21.446c-2.307 2.37-6.103 2.458-8.498.146l18.485 17.819 7.476 7.198c2.395 2.282 6.22 2.194 8.498-.176l20.529-21.418 18.806-19.604c8.235-8.602 7.972-22.383-.613-30.634l-23.011-22.149 1.957 1.902-4.818-4.652c8.468 8.251 8.731 21.974.526 30.517z",
    fill: "#fb2a39",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.3bc075a85eae6098cdecf55e8aeb76e8.svg";
export { ForwardRef as ReactComponent };